import React from "react";
import ButtonIcon from "../button-icon/ButtonIcon";
import { StyledTableCellGroupingChild, StyledTableCellGroupingParent } from "./TableGroupingColumn.style";
import { TABLE_NAMESPACE as ns, getDataItemIndex } from "./utils";
import { StyledHiddenScreenReaderOnly } from "../../utils/StyleUtils";
import translationEN from "./locales/translation-en.json";
import translationFR from "./locales/translation-fr.json";
export const isGroupParent = (dataItem) => dataItem._groupId !== undefined;
export const isGroupChild = (dataItem) => dataItem._parent !== undefined;
export const isGroupChildParent = (dataItem, groupId) => isGroupChild(dataItem) && dataItem._parent === groupId;
export const isParentGroupClosed = (groupingConfig, dataItem) => {
    var _a;
    return isGroupChild(dataItem) &&
        (!groupingConfig.has(dataItem._parent) || ((_a = groupingConfig.get(dataItem._parent)) === null || _a === void 0 ? void 0 : _a.expanded) === false);
};
export const isGroupSelected = (groupingConfig, dataItem) => {
    var _a;
    return Boolean(isGroupParent(dataItem) &&
        groupingConfig.has(dataItem._groupId) &&
        ((_a = groupingConfig.get(dataItem._groupId)) === null || _a === void 0 ? void 0 : _a.selected) === true);
};
export const areGroupChildrenSelected = (selected, groupId) => selected.items.some((item) => isGroupChild(item) && item._parent === groupId);
export const getGroupId = (dataItem) => {
    if (!isGroupParent(dataItem) && !isGroupChild(dataItem)) {
        return null;
    }
    return isGroupParent(dataItem) ? dataItem._groupId : dataItem._parent;
};
export const hasMoreDataInGroups = (groupingConfig) => {
    if (!groupingConfig) {
        return false;
    }
    for (const groupConfig of groupingConfig.values()) {
        if (groupConfig.hasMoreData) {
            return true;
        }
    }
    return false;
};
export const getGroupPaginatedProps = (groupingConfig, dataItem) => {
    const groupId = getGroupId(dataItem);
    if (groupId) {
        const groupConfig = groupingConfig.get(groupId);
        if (groupConfig && groupConfig.onNextPage) {
            return {
                hasMoreData: Boolean(groupConfig.hasMoreData),
                isLoading: groupConfig.isLoading,
                onNextPage: groupConfig.onNextPage,
            };
        }
    }
};
export const isFirstChildInGroup = (data, dataItem, dataItemKey, isGroupingActivated) => {
    if (data) {
        const dataItemIndex = getDataItemIndex(data, dataItem, dataItemKey);
        return Boolean(isGroupingActivated && isGroupChild(dataItem) && dataItemIndex > 0 && isGroupParent(data[dataItemIndex - 1]));
    }
    return false;
};
export const isLastChildInGroup = (data, dataItem, dataItemKey, isGroupingActivated) => {
    if (data) {
        const dataItemIndex = getDataItemIndex(data, dataItem, dataItemKey);
        return Boolean(isGroupingActivated &&
            dataItemIndex > 0 &&
            isGroupChild(dataItem) &&
            (data.length === dataItemIndex + 1 || !isGroupChild(data[dataItemIndex + 1])));
    }
    return false;
};
export const isTableGroupingType = (type) => type === TableGroupingColumn.displayName;
export const groupingCellRenderer = (grouping, onExpandToggle) => 
// eslint-disable-next-line react/display-name
({ dataItem, id, insightsAttr }) => {
    var _a;
    if (isGroupParent(dataItem)) {
        const groupId = dataItem._groupId;
        const isExpanded = grouping.has(groupId) && ((_a = grouping.get(groupId)) === null || _a === void 0 ? void 0 : _a.expanded) === true;
        return (React.createElement(StyledTableCellGroupingParent, { onClick: (e) => e.stopPropagation() },
            React.createElement(ButtonIcon, { id: `${id}-grouping`, "data-insights": insightsAttr && `${insightsAttr}-grouping`, variant: "bare", "aria-label": isExpanded ? "close" : "expand", "aria-expanded": isExpanded, iconName: isExpanded ? "angleDown" : "angleRight", size: "medium", onClick: () => {
                    onExpandToggle(groupId);
                } })));
    }
    else if (isGroupChild(dataItem)) {
        return React.createElement(StyledTableCellGroupingChild, null);
    }
    return React.createElement(StyledTableCellGroupingParent, null);
};
export const groupingHeaderCellRenderer = (t, nxI18n) => {
    nxI18n.addResources("en", ns, translationEN);
    nxI18n.addResources("fr", ns, translationFR);
    const renderer = () => (React.createElement(StyledTableCellGroupingParent, null,
        React.createElement(StyledHiddenScreenReaderOnly, null, t("groupingHeader", { ns }))));
    renderer.displayName = "groupingHeaderCellRenderer";
    return renderer;
};
const TableGroupingColumn = () => React.createElement(React.Fragment, null);
TableGroupingColumn.displayName = "TableGroupingColumn";
export default TableGroupingColumn;
//# sourceMappingURL=TableGroupingColumn.js.map